export const chargerService = {
    getLocationById,
    deleteLocation,
    addChargerLocation,
    updateLocation,
    getChargerData
};

function getChargerData(userId){
    const requestOptions = {
        user_id:userId,
    };
    return window.axios.post('get-charger-by-user-id', requestOptions);
}

function getLocationById(locationId) {
    const requestOptions = {
        charger_id:locationId,
    };
    return window.axios.post('get-charger-by-id', requestOptions);
}

function addChargerLocation(
    data
) {
    
    return window.axios.post('add-charger', data);
}

function updateLocation(
   data
) {
    return window.axios.post('update-charger', data);
}

function deleteLocation(id) {
    const requestOptions = {
        charger_id:id,
    };
    return window.axios.post('delete-charger', requestOptions);
}
